/*!
 * Copyright © 2020-2025. Verizon Connect Ireland Limited. All rights reserved.
 */

import { NgModule } from '@angular/core';
import { ErrorStateMatcher } from '@angular/material/core';
import { RouterModule } from '@angular/router';

import { environment } from '../../../../environments/environment';
import { CACHE_NONCE } from '../../../core/config/cache-nonce.token';
import { SharedModule } from '../../../shared/shared.module';
import { NotPristineAndDirtyErrorStateMatcher } from '../../../shared/validators';
import { VerificationCodeComponent } from '../../components/verification-code/verification-code.component';
import { VerifyYourAccountComponent } from './verify-your-account.component';

@NgModule({
  declarations: [VerifyYourAccountComponent, VerificationCodeComponent],
  imports: [
    RouterModule.forChild([
      {
        path: '',
        pathMatch: 'full',
        component: VerifyYourAccountComponent
      }
    ]),
    SharedModule
  ],
  providers: [
    { provide: ErrorStateMatcher, useClass: NotPristineAndDirtyErrorStateMatcher },
    { provide: CACHE_NONCE, useValue: environment.config.cacheNonce }
  ],
  exports: [VerifyYourAccountComponent]
})
export class VerifyYourAccountModule {}
